/* RTT Sealant — homepage interactions (before/after slider) */
(function () {
  function initBA() {
    document.querySelectorAll('.rtt-ba').forEach(function (ba) {
      var r = ba.querySelector('.rtt-ba-range');
      if (!r) return;
      function update() { ba.style.setProperty('--rtt-pos', r.value + '%'); }
      r.addEventListener('input', update);
      update();
    });
  }
  if (document.readyState !== 'loading') initBA();
  else document.addEventListener('DOMContentLoaded', initBA);
})();
